export default "__VITE_ASSET__Dvc$54rL__"